import { lazy, Suspense, useCallback, useEffect, useRef, useState } from 'react';
import { supabase } from '../../lib/supabase';
import { DocumentDetail, fileLabel } from './detailModel';
const PdfViewer = lazy(() => import('./PdfViewer'));
export default function DocumentPreview({ doc, pageRequest }: { doc: DocumentDetail; pageRequest?: {page:number;requestId:number} }) {
  const [url, setUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const generation = useRef(0);
  const objectUrl = useRef<string | null>(null);
  const preview = useCallback(async () => {
    const id = ++generation.current;
    setLoading(true);
    setError(false);
    try {
      const { data, error } = await supabase.storage
        .from('documents')
        .download(doc.file_location);
      if (id !== generation.current) return;
      if (error || !data) throw error || new Error('Archivo no disponible');
      if (objectUrl.current) URL.revokeObjectURL(objectUrl.current);
      objectUrl.current = URL.createObjectURL(data);
      setUrl(objectUrl.current);
    } catch {
      if (id === generation.current) setError(true);
    } finally {
      if (id === generation.current) setLoading(false);
    }
  }, [doc.file_location]);
  useEffect(() => {
    setUrl(null);
    setError(false);
    if (doc.file_location?.toLowerCase().endsWith('.pdf')) void preview();
    return () => {
      generation.current++;
      if (objectUrl.current) URL.revokeObjectURL(objectUrl.current);
      objectUrl.current = null;
    };
  }, [doc.id, doc.file_location, preview]);
  if (!doc.file_location?.toLowerCase().endsWith('.pdf'))
    return (
      <div className="flex items-center justify-center bg-slate-50 p-8 text-center text-sm text-slate-600">
        Este formato no tiene vista previa. Descarga el archivo para revisarlo.
      </div>
    );
  return (
    <div className="bg-slate-50">
      {url ? (
        <Suspense fallback={<p role="status" className="p-8 text-center text-sm text-slate-500">Preparando visor…</p>}>
          <PdfViewer key={doc.id} url={url} name={fileLabel(doc)} pageRequest={pageRequest} />
        </Suspense>
      ) : (
        <div className="flex min-h-72 flex-col items-center justify-center gap-4 p-8 text-center">
          {loading && <p role="status" className="text-sm text-slate-600">Cargando PDF…</p>}
          {error && <button onClick={preview} className="rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-blue-700">Reintentar vista previa</button>}
          {error && (
            <p role="alert" className="text-sm text-red-800">
              No se pudo cargar el archivo. Puedes reintentar o descargarlo.
            </p>
          )}
        </div>
      )}
    </div>
  );
}
